module.exports = __webpack_public_path__ + "static/ActaDisplay-ExtraBold-e42db1f6796a9df58ca5ce1c01cb0d6d.woff";